import { useElements, useStripe } from '@stripe/react-stripe-js';
import type { CreateTokenCardData, Token } from '@stripe/stripe-js';
import { useCallback } from 'react';

import { trackEvent } from '#/utils/analytics/track/trackEvent';

type CreateTokenFn = (data: {
  additionalData: CreateTokenCardData;
}) => Promise<Token>;

export function useStripeCreateCreditCardToken(): {
  createStripeCreditCardToken: CreateTokenFn;
} {
  const stripe = useStripe();
  const elements = useElements();

  const createStripeCreditCardToken: CreateTokenFn = useCallback(
    async ({ additionalData }): Promise<Token> => {
      // @ts-expect-error TS(2531): Object is possibly 'null'.
      const { token, error } = await stripe.createToken(
        // @ts-expect-error TS(2531): Object is possibly 'null'.
        elements.getElement('cardNumber'),
        additionalData,
      );

      if (token) return token;

      trackEvent('Error: Paying Card', {
        new_card: true,
        code: error.code,
        message: error.message,
      });

      throw new Error(
        error?.message ??
          'Something wrong happened while creating a Stripe token for this credit card.',
      );
    },
    [stripe, elements],
  );

  return { createStripeCreditCardToken };
}
